import {FC, useEffect, useState} from 'react'
import {KTIcon, useDebounce} from '../../../../../_metronic/helpers'

type Props = {
  handleFormModal: (value: boolean) => void
  handleList: (pagina: number, limite: number, query?: string) => void
}

const ReceptionPageHeader: FC<Props> = ({handleFormModal, handleList}) => {
  const [searchTerm, setSearchTerm] = useState<string>('')
  const [isFirstLoad, setIsFirstLoad] = useState<boolean>(true)

  const debouncedSearchTerm = useDebounce(searchTerm, 150)

  useEffect(() => {
    if (debouncedSearchTerm !== undefined && searchTerm !== undefined && !isFirstLoad) {
      handleList(1, 10, debouncedSearchTerm)
    }

    setIsFirstLoad(false)
  }, [debouncedSearchTerm])

  return (
    <div className='card-header border-0 pt-6'>
      <div className='card-title'>
        {/* begin::Search */}
        <div className='d-flex align-items-center position-relative my-1'>
          <KTIcon iconName='magnifier' className='fs-1 position-absolute ms-6' />
          <input
            type='text'
            data-kt-user-table-filter='search'
            className='form-control form-control-solid w-250px ps-14'
            placeholder='Pesquisar número da recepção'
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
        {/* end::Search */}
      </div>
      {/* begin::Card toolbar */}
      <div className='card-toolbar'>
        {/* begin::Add user */}
        <button type='button' className='btn btn-primary' onClick={() => handleFormModal(true)}>
          <KTIcon iconName='plus' className='fs-2' />
          Recepcionar Malotes
        </button>
      </div>
      {/* end::Card toolbar */}
    </div>
  )
}

export default ReceptionPageHeader
